export default __webpack_public_path__ + "static/media/sa1.fb773be4.jpg";